import { useFlag } from '@unleash/proxy-client-react'
import getConfig from 'next/config'
import { useEffect } from 'react'
import { hotjar } from 'react-hotjar'

const {
  publicRuntimeConfig: { HOTJAR_SITE_ID, HOTJAR_SITE_VERSION }
} = getConfig()

export default function useHotjar(): void {
  const isRestaurantTracked = useFlag('hotjar')

  useEffect(() => {
    if (HOTJAR_SITE_ID === undefined) {
      return
    }
    if (hotjar.initialized()) {
      return
    }

    if (isRestaurantTracked) {
      hotjar.initialize(HOTJAR_SITE_ID, HOTJAR_SITE_VERSION)
    }
  }, [isRestaurantTracked])
}
